exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.customers[data-v-4252197f]{margin-top:2em}ul.customers-list[data-v-4252197f]{margin:0;padding:0;list-style-type:none}ul.customers-list li[data-v-4252197f]{padding:2em;border-bottom:1px solid #000}input[name=query][data-v-4252197f]{padding:5px 10px;border:1px solid grey;width:100%;max-width:500px}", ""]);

// exports
